import { api_companies_helmets_request_extension_post, Helmet } from 'abi'
import { CloseIcon, WarningIcon } from 'icons'
import { Component, onMount, Show } from 'solid-js'

import { addAlert, LoadingDots, setPopup } from 'components'
import { createStore, unwrap } from 'solid-js/store'
import './style/extentionreq.scss'

interface ExtentionReqProps {
    helmet: Helmet

    onClose(): void
    onSave(): void
}
const ExtentionReq: Component<ExtentionReqProps> = P => {
    const [state, setState] = createStore({
        text: '',
        loading: false,
        error: false,
    })

    onMount(() => {
        if (P.helmet.company !== null) return

        addAlert({
            type: 'info',
            subject: 'بیمه برای شرکتی نیست!',
            content: 'برای ثبت الحاقیه بیمه باید مطلق به شرکتی باشد',
            timeout: 3,
        })
        P.onClose()
    })

    const close = () => {
        if (state.loading) return

        if (!isDisable()) {
            setPopup({
                type: 'warning',
                Icon: WarningIcon,
                show: true,
                title: 'متن خود را ارسال نکردید!',
                content: 'بعد از خروج متن شما ذخیره نمیشود، ادامه میدهید؟',
                onSubmit: P.onClose,
            })
            return
        }

        P.onClose()
    }

    const onSubmit = async () => {
        if (isDisable()) {
            addAlert({
                type: 'error',
                timeout: 3,
                subject: 'متن درخواست خالی است!',
            })
            return
        }

        let detail = unwrap(state.text)

        setState('loading', true)

        let res = await api_companies_helmets_request_extension_post(
            {
                cid: P.helmet.company!,
                hid: P.helmet.id,
            },
            {
                detail,
            }
        )

        setState('loading', false)

        if (!res.ok()) return setState('error', true)

        P.onSave()
    }

    const isDisable = () => state.text.length == 0

    return (
        <div class='extention-req-cmp' onclick={close}>
            <form
                class='extention-req-wrapper'
                onsubmit={e => {
                    e.preventDefault()
                    onSubmit()
                }}
                onclick={e => e.stopPropagation()}
            >
                <Show when={state.loading}>
                    <div
                        class='loader title_hero'
                        classList={{ show: state.loading }}
                    >
                        <LoadingDots />
                        درحال ثبت درخواست
                    </div>
                </Show>
                <Show when={state.error}>
                    <div
                        class='error-status title_hero'
                        classList={{ show: state.loading }}
                    >
                        <CloseIcon />
                        <p>درخواست ثبت نشد!</p>
                        <span class='title_smaller'>
                            لطفا بعد از مدتی دوباره تلاش کنید
                        </span>
                    </div>
                </Show>

                <div class='scaler'></div>

                <div class='close' role='button' onclick={close}>
                    <CloseIcon />
                </div>

                <div class='card'>
                    <div class='header'>
                        <div class='sub title_smaller'>الحاقیه بیمه شماره</div>
                        <div class='head section_title'>{P.helmet.id}</div>
                    </div>

                    <textarea
                        class='text-wrapper title_smaller'
                        value={state.text}
                        oninput={e =>
                            setState('text', e.currentTarget.value.trim())
                        }
                        name=''
                        placeholder='متن درخواست خود را اینجا بنویسید...'
                        id=''
                    ></textarea>

                    <div class='cta-wrapper'>
                        <button class='title_smaller' disabled={isDisable()}>
                            ثبت درخواست
                        </button>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default ExtentionReq
